import React from "react";
import PropTypes from "prop-types";
import Image from "../image";
import { getCDNProviderToUse } from "../../utils/base";

const CardWithBgImage = ({
  featuredImage,
  title,
  featuredImageFallback,
  isComingSoon,
  containerClass,
  innerContainerClass,
  scaledImage,
  programType
}) => {
  return (
    <>
      <div className={`flex ${containerClass}`}>
        <div
          className={`flex flex-col justify-between border experience-tab-card-image-border-color h-72 w-full bg-cover bg-center rounded-xs border-light relative bg-gray-darkest overflow-hidden ${innerContainerClass}`}
        >
          <Image
            imageAlt={""}
            image={!isComingSoon ? scaledImage : scaledImage}
            imageClass={"rounded-xs h-72 object-center object-cover"}
            sourceUrl={
              !isComingSoon
                ? getCDNProviderToUse({
                    width: 500,
                    uri: featuredImage?.publicURL ?? featuredImageFallback
                  })
                : `${featuredImageFallback}`
            }
          />
          {/* <div className="flex items-center justify-between pr-8 ml-4" /> */}
          <div className="absolute bottom-0 z-10 pr-4 pl-4">
            {programType && (
              <div className="overflow-hidden">
                <span className="bg-black-lighter planet:bg-gray-darker text-[12px] text-center text-white uppercase px-2 pt-2 pb-2">
                  {programType}
                </span>
              </div>
            )}

            <div className="p-2 bg-white rounded-tr-md">
              <p className="text-sm text-center gvi-dark-gray-text">{title}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

CardWithBgImage.defaultProps = {
  containerClass: "",
  innerContainerClass: ""
};

CardWithBgImage.propTypes = {
  containerClass: PropTypes.string,
  innerContainerClass: PropTypes.string
};

export default CardWithBgImage;
